/*
 * pdp-rail.js — anchor the Reels action rail to the bottom of the IMAGE.
 * The rail lives in .product__media-wrapper, but that wrapper is taller than the
 * image (it also holds the slider dots/counter), so a plain bottom:14px left the
 * rail hanging below the picture. Measure the real gap under the image and set
 * the rail's bottom offset so it sits inside the lower-right of the image.
 */
(function () {
  function place() {
    document.querySelectorAll('.product--ig .product__media-wrapper').forEach(function (wrap) {
      var rail = wrap.querySelector('.pdpig__rail');
      if (!rail) return;
      var img = wrap.querySelector('.product__media-item.is-active') || wrap.querySelector('.product__media-item');
      if (!img) return;
      var wr = wrap.getBoundingClientRect();
      var ir = img.getBoundingClientRect();
      var gapBelowImage = Math.max(0, wr.bottom - ir.bottom); // dots/counter height
      rail.style.bottom = Math.round(gapBelowImage + 14) + 'px';
    });
  }
  function boot() { place(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', place);
  window.addEventListener('resize', place);
  window.addEventListener('orientationchange', place);
  document.addEventListener('slideChanged', place, true); // media-gallery fires this
})();
